var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2235 12.526C19.6375 9.405 19.3455 7.844 18.2335 6.922C17.1245 6 15.5365 6 12.3615 6H11.6395C8.46447 6 6.87647 6 5.76547 6.922C4.65547 7.844 4.36247 9.405 3.77647 12.526C2.95447 16.915 2.54247 19.109 3.74247 20.555C4.94147 22 7.17347 22 11.6385 22H12.3605C16.8255 22 19.0585 22 20.2575 20.555C20.9535 19.715 21.1075 18.625 20.9535 17M8.99947 6V5C8.99947 4.20435 9.31554 3.44129 9.87815 2.87868C10.4408 2.31607 11.2038 2 11.9995 2C12.7951 2 13.5582 2.31607 14.1208 2.87868C14.6834 3.44129 14.9995 4.20435 14.9995 5V6",
    stroke: "#285430",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagIcon);
export default __webpack_public_path__ + "static/media/bag-icon.d90ee8ed30a2c19f50a270090a772d9c.svg";
export { ForwardRef as ReactComponent };